module.exports = __webpack_public_path__ + "html/studio-header_beba036219c36b94443a9c647aacd7fb.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/studio-header.html
// module id = 1aEF
// module chunks = 153